/* Core & libraries */
import React, {useMemo} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage,} from "react-intl";
import {ErrorMessage, Field, Formik} from "formik";

/* Helpers, constants, custom methods, internal libraries */
import {createValidationPolicyYupSchema, useValidationEditProfileService} from "resources/validations/validations";

/* Components */
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Styles */
import styles from "./styles.js"

const Content = props => {
  const {setShowModal, handleSubmit, fieldLabel, fieldName, value} = props;

  const theme = useTheme();
  const classes = styles({theme});

  const {editProfileValidationObj} = useValidationEditProfileService({fieldName, fieldLabel});

  const validationSchema = useMemo(() => createValidationPolicyYupSchema(editProfileValidationObj), [editProfileValidationObj]);

  return (
    <div className={classes.modalContent}>
      <Formik
        initialValues={{
          [fieldName]: value
        }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit}>
              <div className={classes.inputContainer}>
                <label htmlFor={fieldName} className={classes.label}>
                  {fieldLabel}
                </label>
                <Field
                  placeholder={fieldLabel}
                  type="text"
                  name={fieldName}
                  id={fieldName}
                  className={
                    errors[fieldName] && touched[fieldName]
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name={fieldName}
                  component="span"
                  className={classes.error}
                />
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row className={classes.btnsRow}>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="edit.UC.input.modal.cancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove}>
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleSubmit}
                        type="primary"
                        text={<FormattedMessage id="edit.UC.input.modal.submit"/>}
                        disabled={!values[fieldName] || Object.values(errors).length > 0}
                        spinner={{
                          name: "editUcInputModalSpinner",
                          size: 20,
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;
